import React, { useEffect, useState } from "react";
import * as  FileSaver  from "file-saver";
import XLSX from 'sheetjs-style'
import Button from '@mui/material/Button';
import UploadOutlinedIcon from '@mui/icons-material/UploadOutlined';


const ExportExcel = ({excelData, fileName}) => {
  const fileType  = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const fileExtension = '.xlsx';

  const exportToExcel = async () => {
    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = { Sheets: { 'data': ws}, SheetNames: ['data']};
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array'});
    const data_excel = new Blob([excelBuffer], { type: fileType});
    FileSaver.saveAs(data_excel, fileName + fileExtension);
  }

  return (
      <>
        
    <Button
      variant="outlined"
      sx={{
        fontSize: 16,
        fontWeight: 600,
        color: '#00B3BD',
        borderColor: '#00B3BD',
        background: '#ffffff',
        borderRadius: 1.1,
        minHeight: 40,
        minWidth: 90,
        px: 2,
        '&:hover': {
          borderColor: '#00B3BD',
          background: '#f4ffff',
        },
      }}
      startIcon={<UploadOutlinedIcon sx={{ color: '#00B3BD', fontSize: 22 }} />}
      onClick={() => { exportToExcel(fileName); }}
    >
        Export 
    </Button>

      </>
  )

}

export default ExportExcel;